import React from 'react';
import styled from 'styled-components';

const getSpacing = (spacing, position) => {
  const padding = spacing[position];

  return padding ? `${padding}px` : '0px';
};

export const fmtPadding = spacing => {
  if (!spacing) {
    return '0px';
  }

  if (typeof spacing == 'number') {
    return `${spacing}px`;
  }

  const padding = ['top', 'right', 'bottom', 'left'].map(p => getSpacing(spacing, p));

  return padding.join(' ');
};

export const BoxUI = styled.div`
  display: flex;
  padding: 10px;
  flex: ${({ fluid }) => (fluid ? '1' : 'none')};
  flex-direction: ${({ direction }) => direction};
  padding: ${({ spacing }) => fmtPadding(spacing)};
`;

export const Box = ({ children, ...props }) => <BoxUI {...props}>{children}</BoxUI>;
